import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import {updateIssues} from 'common/src/modules/campaigns/store/campaignIssues/campaignIssues.slice';
import {CLStore} from 'common/src/redux/store';

/**
 * Refreshes campaign issues after card operations (add, update, delete)
 * @param store - Redux store instance
 */
export default async function refreshCampaignIssues(store: CLStore): Promise<void> {
  const state = store.getState();
  const campaign = state.campaignPage?.campaignTree?.campaign;
  const versionId = state.campaignPage?.campaignTree?.versionId;

  if (!campaign || !versionId) {
    return;
  }

  try {
    const issues = await campaignsApi.getCampaignIssues(campaign.id, versionId);

    store.dispatch(updateIssues(issues));
  } catch (error) {
    // Silently fail - don't interrupt the card operation if issue refresh fails
    console.error('Failed to refresh campaign issues:', error);
  }
}
